import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllCities, updateCityById } from "../actions/cityActions";
import { getAllStores, updateStore } from "../actions/storeActions";
import {
  getAllCustomers,
  getAllDrivers,
  updateUserById,
} from "../actions/userActions";
import {
  getAllSubCategories,
  updateSubCategoriesById,
} from "../actions/subCategories";
import { getAllCategories, updateCategoriesById } from "../actions/categories";

const ActiveFormModal = ({
  openActiveModal,
  showActiveModal,
  current,
  handleSubmit,
}) => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const city = useSelector((state) => state.city);
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  // const handleChange = (fieldName) => (event) => {
  //   setValues({
  //     ...values,
  //     [fieldName]: event.target.value,
  //   });
  // };
  // const currentStatus = async () => {
  //   try {
  //     setValues({
  //       id: "",
  //       // name: "",
  //       // longitude: "",
  //       // latitude: "",
  //       status: "",
  //     });
  //     setValues({
  //       id: current?.id,
  //       // name: current.name,
  //       // longitude: current.longitude,
  //       // latitude: current.latitude,
  //       status: current.status,
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   currentStatus();
  // }, [current]);

  // const statusData = {
  //   _id: values.id,
  //   // name: values.name,
  //   // longitude: values.longitude,
  //   // latitude: values.latitude,
  //   status: values.status,
  // };

  // // const handleSubmit = async (event) => {
  // //   event.preventDefault();
  // //   const updatedStatus = !current.status; // Toggle the boolean value
  // //   const statusData = {
  // //     _id: values.id,
  // //     status: updatedStatus, // Assign the toggled value
  // //   };
  // //   dispatch(updateCityById(statusData));
  // //   dispatch(updateStore(statusData));
  // //   dispatch(updateUserById(statusData));
  // //   dispatch(updateCategoriesById(statusData));
  // //   dispatch(updateSubCategoriesById(statusData));

  // //   setTimeout(() => {
  // //     dispatch(getAllCities());
  // //     dispatch(getAllStores());
  // //     // dispatch(getAllCustomers());
  // //     dispatch(getAllDrivers());
  // //     dispatch(getAllCategories());
  // //     dispatch(getAllSubCategories());
  // //   }, 1000);
  // //   openActiveModal();
  // // };

  // // const handleSubmit = async (event) => {
  // //   event.preventDefault();

  // //   const updatedStatus = !current.status; // Toggle the boolean value
  // //   const statusData = {
  // //     _id: values.id,
  // //     status: updatedStatus, // Assign the toggled value
  // //   };

  // //   try {
  // //     // Run all update calls in parallel
  // //     await Promise.all([
  // //       dispatch(updateCityById(statusData)),
  // //       dispatch(updateStore(statusData)),
  // //       dispatch(updateUserById(statusData)),
  // //       dispatch(updateCategoriesById(statusData)),
  // //       dispatch(updateSubCategoriesById(statusData)),
  // //     ]);

  // //     // Fetch all necessary data after updates are complete
  // //     await Promise.all([
  // //       dispatch(getAllCities()),
  // //       dispatch(getAllStores()),
  // //       dispatch(getAllDrivers()),
  // //       dispatch(getAllCategories()),
  // //       dispatch(getAllSubCategories()),
  // //     ]);
  // //   } catch (error) {
  // //     console.error("Error updating data:", error);
  // //   }

  // //   openActiveModal();
  // // };

  // console.log(current, "current");

  return (
    <>
      <div
        className={`modal fade ${showActiveModal === true ? "show" : "hide"}`}
        id="addnewModal"
        tabIndex="-1"
        aria-labelledby="addnewModalLabel"
        // aria-hidden="true"
        onClick={(e) => {
          // Check if the click occurred outside the modal content
          if (e.target === e.currentTarget) {
            openActiveModal(); // Call your close modal function
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="col-md-12">
                  <div className="text-center mb-5">
                    {/* <label
                      className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                      htmlFor="avatar_upload"
                    >
                      <span className="avatar-edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                        >
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                      </span>
                    </label> */}
                    {/* <!-- Image Upload Guidance --> */}
                    <h2
                      className="fw-light text-info"
                      //   style={{ fontSize: "12px" }}
                    >
                      Are you sure?
                    </h2>
                    <p>To update this item?</p>
                  </div>
                </div>

                <div
                  className="modal-footer"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => openActiveModal()}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveFormModal;
